import { Box, Slide, Stack } from '@mui/material'
import { FC, ForwardRefExoticComponent, RefAttributes, RefObject } from 'react'
import { LocationSearch } from '../../LocationSearch'
import { LayerSwitcher } from '../Layers'
import { CDLLegend } from '../Layers/CDLLayer'
import { MapControlLayout } from '../MapControlLayout'
import { useGeometryEditorStateContext } from './GeometryEditorContext'
import { Toolbox, ToolboxProps } from './Toolbox'

interface LayerControlsProps extends ToolboxProps {
  onLocationSelected?: (bbox: any) => void
  LayerOverlay?: ForwardRefExoticComponent<{} & RefAttributes<HTMLElement>>
  container: RefObject<HTMLElement>
  displayTools?: boolean
  onBack?: () => void
  onNext?: () => void
}

export const LayerControls: FC<LayerControlsProps> = ({
  children,
  onDifference,
  onDifferenceSelected,
  onUnion,
  onUnionSelected,
  onLocationSelected,
  LayerOverlay,
  displayTools = true,
  onBack,
  onNext,
}) => {
  const { container } = useGeometryEditorStateContext()

  return (
    <MapControlLayout
      upperLeft={
        <>
          <Slide in={displayTools} container={container.current}>
            <Toolbox
              onUnion={onUnion}
              onUnionSelected={onUnionSelected}
              onDifference={onDifference}
              onDifferenceSelected={onDifferenceSelected}
              onBack={onBack}
              onNext={onNext}
            />
          </Slide>
          <Slide in={!displayTools} container={container.current}>
            {!!LayerOverlay ? <LayerOverlay /> : <div />}
          </Slide>
        </>
      }
      upperRight={
        <Slide in={!!onLocationSelected && displayTools} container={container.current}>
          <Stack direction="row">
            <Box style={{ flex: 1 }} />
            <LocationSearch onLocationSelected={onLocationSelected} />
          </Stack>
        </Slide>
      }
      lowerLeft={
        <>
          <CDLLegend />
          <LayerSwitcher />
        </>
      }
      lowerRight={!!children && children}
    />
  )
}
